import Store from 'lightningjs-redux';
import { getGdprNoticeVisibility } from '../../../../logic/gdprNotice/gdprNotice.selectors';
import { getPromptBeforeExitFeature } from '../../../../logic/features/features.selectors';
import { getPopupData } from '../../../../logic/popup/popup.selectors';
import { isAppInitialized } from '../../../../logic/app/app.selectors';
import { getCurrentRoute, isOpenedViaDeeplink } from '../../../../logic/routing/routing.selectors';

const mapControllers = instance => ({
  promptBeforeExitFeature: {
    selector: getPromptBeforeExitFeature,
    callback: value => {
      instance.promptBeforeExitFeature = value;
    },
  },
  gdprNoticeVisibility: {
    selector: getGdprNoticeVisibility,
    callback: value => {
      instance.shouldDisplayCookieConsent = value;
    },
  },
  showPopup: {
    selector: getPopupData,
    callback: value => {
      instance.popUp = value;
    },
  },
  isAppInitialized: {
    selector: isAppInitialized,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.isAppInitialized = value;
    },
  },
  isOpenedViaDeeplink: {
    selector: isOpenedViaDeeplink,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.isOpenedViaDeeplink = value;
    },
  },
  currentRoute: {
    selector: getCurrentRoute,
    callback: value => {
      instance.currentRoute = value;
    },
  },
});

export default Store.control(mapControllers);
